var _desc, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1280,
    height: 1024,
    viewBox: "0 0 1280 1024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.3.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 640 512)",
    id: "background-logo"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    x: -640,
    y: -512,
    rx: 0,
    ry: 0,
    width: 1280,
    height: 1024
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9211538461538462 0 0 1.9211538461538462 459.0172675299235 368.8817744260277)",
    id: "text-logo"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "text-logo-path-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-199.575, 52.425)",
    d: "M 93 -21 L 37.95 -21 C 30 -21 27 -24 27 -31.95 L 27 -105 L 6 -105 L 6 -31.95 C 6 -13.8 19.8 0 37.95 0 L 93 0 Z M 193.05 -20.85 L 138 -20.85 C 130.05 -20.85 127.05 -23.85 127.05 -31.8 L 127.05 -34.5 L 106.05 -34.5 L 106.05 -31.8 C 106.05 -13.65 119.85 0.15 138 0.15 L 193.05 0.15 Z M 106.05 -42 L 182.55 -42 L 182.55 -63 L 127.05 -63 L 127.05 -84 L 193.05 -84 L 193.05 -105 L 106.05 -105 Z M 293.1 0 L 293.1 -73.05 C 293.1 -91.2 279.3 -105 261.15 -105 L 238.05 -105 C 219.9 -105 206.1 -91.2 206.1 -73.05 L 206.1 0 L 227.1 0 L 227.1 -73.05 C 227.1 -81 230.1 -84 238.05 -84 L 261.15 -84 C 269.1 -84 272.1 -81 272.1 -73.05 L 272.1 -63 L 234.6 -63 L 234.6 -42 L 272.1 -42 L 272.1 0 Z M 306.15 -42 L 361.2 -42 C 379.2 -42 393.15 -55.2 393.15 -73.05 C 393.15 -91.2 379.35 -105 361.2 -105 L 306.15 -105 Z M 306.15 0 L 327.15 0 L 327.15 -34.5 L 306.15 -34.5 Z M 327.15 -63 L 327.15 -84 L 361.2 -84 C 369.15 -84 372.15 -81 372.15 -73.05 C 372.15 -65.7 369.3 -63 361.2 -63 Z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9211538461538462 0 0 1.9211538461538462 747.5635051971622 589.420240875512)",
    id: "tagline-3253a1ee-9ce9-440c-ba68-cf59dddf6c79-logo"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "tagline-3253a1ee-9ce9-440c-ba68-cf59dddf6c79-logo-path-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-249.6, 52.425)",
    d: "M 6 -42 L 61.05 -42 C 79.05 -42 93 -55.2 93 -73.05 C 93 -91.2 79.2 -105 61.05 -105 L 6 -105 Z M 6 0 L 27 0 L 27 -34.5 L 6 -34.5 Z M 27 -63 L 27 -84 L 61.05 -84 C 69 -84 72 -81 72 -73.05 C 72 -65.7 69.15 -63 61.05 -63 Z M 193.05 -21 L 138 -21 C 130.05 -21 127.05 -24 127.05 -31.95 L 127.05 -105 L 106.05 -105 L 106.05 -31.95 C 106.05 -13.8 119.85 0 138 0 L 193.05 0 Z M 293.1 0 L 293.1 -73.05 C 293.1 -91.2 279.3 -105 261.15 -105 L 238.05 -105 C 219.9 -105 206.1 -91.2 206.1 -73.05 L 206.1 0 L 227.1 0 L 227.1 -73.05 C 227.1 -81 230.1 -84 238.05 -84 L 261.15 -84 C 269.1 -84 272.1 -81 272.1 -73.05 L 272.1 -63 L 234.6 -63 L 234.6 -42 L 272.1 -42 L 272.1 0 Z M 393.15 -70.5 L 393.15 -73.05 C 393.15 -91.2 379.35 -105 361.2 -105 L 338.1 -105 C 319.95 -105 306.15 -91.2 306.15 -73.05 L 306.15 -31.95 C 306.15 -13.8 319.95 0 338.1 0 L 361.2 0 C 379.35 0 393.15 -13.8 393.15 -31.95 L 393.15 -34.65 L 372.15 -34.65 L 372.15 -31.95 C 372.15 -24 369.15 -21 361.2 -21 L 338.1 -21 C 330.15 -21 327.15 -24 327.15 -31.95 L 327.15 -73.05 C 327.15 -81 330.15 -84 338.1 -84 L 361.2 -84 C 369.15 -84 372.15 -81 372.15 -73.05 L 372.15 -70.5 Z M 493.2 -20.85 L 438.15 -20.85 C 430.2 -20.85 427.2 -23.85 427.2 -31.8 L 427.2 -34.5 L 406.2 -34.5 L 406.2 -31.8 C 406.2 -13.65 420 0.15 438.15 0.15 L 493.2 0.15 Z M 406.2 -42 L 482.7 -42 L 482.7 -63 L 427.2 -63 L 427.2 -84 L 493.2 -84 L 493.2 -105 L 406.2 -105 Z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9211538461538462 0 0 1.9211538461538462 172.94638981254678 368.7376878875661)",
    id: "tagline-1d370821-5ab5-4b90-8108-2bf08f15c6a7-logo"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "tagline-1d370821-5ab5-4b90-8108-2bf08f15c6a7-logo-path-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(127,216,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-49.5, 52.5)",
    d: "M 93 -21 L 37.95 -21 C 30 -21 27 -24 27 -31.95 L 27 -105 L 6 -105 L 6 -31.95 C 6 -13.8 19.8 0 37.95 0 L 93 0 Z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9211538461538462 0 0 1.9211538461538462 363.92015214530807 589.2761543370505)",
    id: "tagline-7763e6e5-7cde-4c39-b784-e9a0e87d646d-logo"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "tagline-7763e6e5-7cde-4c39-b784-e9a0e87d646d-logo-path-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,190,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-49.5, 52.5)",
    d: "M 6 -42 L 61.05 -42 C 79.05 -42 93 -55.2 93 -73.05 C 93 -91.2 79.2 -105 61.05 -105 L 6 -105 Z M 6 0 L 27 0 L 27 -34.5 L 6 -34.5 Z M 27 -63 L 27 -84 L 61.05 -84 C 69 -84 72 -81 72 -73.05 C 72 -65.7 69.15 -63 61.05 -63 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main_logo.dbef243c2ed2d75e18963120878d9fbd.svg";
export { ForwardRef as ReactComponent };